import { atom } from 'jotai'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { CampaignForm } from '../../views'

export const [formAtom, useFormListener] = atomWithListeners<CampaignForm | undefined>(undefined)

export const formStatusAtom = atom<LifecycleState>('idle')
export const formSavingAtom = atom<PersistenceState>('idle')
